import React, { Component } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './ContentSlider.css';

class ContentSlider extends Component {
  componentDidMount() {
    if (typeof this.props.activeIndex !== 'undefined') {
      this.goToSlide();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.activeIndex !== prevProps.activeIndex) {
      this.goToSlide();
    }
  }

  goToSlide() {
    const { activeIndex } = this.props;
    const { children } = this.slider.props;
    const noOfSlides = children.length;
    let indexToSlideTo = activeIndex;

    if (noOfSlides === activeIndex + 1) {
      indexToSlideTo = indexToSlideTo - 2;
    }

    this.slider.slickGoTo(indexToSlideTo);
  }

  render() {
    const { children, size } = this.props;
    const slideSize = size => {
      switch (size) {
        case 'five-wide':
          return 5;
        case 'four-wide':
          return 4;
        case 'three-wide':
          return 3;
        case 'two-wide':
          return 2;
        default:
          return 1;
      }
    };
    const slidesToShowAboveMobile = separator => {
      if (slideSize(size) === 1) {
        return 1;
      }
      if (slideSize(size) < children.length) {
        return slideSize(size) - separator;
      }
      return children.length;
    };

    const sliderSettings = {
      centerMode: slideSize(size) > 1 ? false : true,
      centerPadding: '0px',
      slidesToShow: slidesToShowAboveMobile(0.5),
      draggable: false,
      infinite: slideSize(size) > 1 ? false : true,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            centerMode: false,
            infinite: false,
            centerPadding: '0px',
            slidesToShow:
              slideSize(size) > 1
                ? children.length > 3
                  ? 2.5
                  : children.length
                : 1
          }
        },
        {
          breakpoint: 640,
          settings: {
            centerMode: false,
            infinite: false,
            centerPadding: '0px',
            slidesToShow: slideSize(size) > 1 ? 1.5 : 1
          }
        }
      ]
    };

    return (
      <div className="content-slider">
        <Slider ref={slider => (this.slider = slider)} {...sliderSettings}>
          {children}
        </Slider>
      </div>
    );
  }
}

export default ContentSlider;



// WEBPACK FOOTER //
// ./src/components/ContentSlider/ContentSlider.js